import { FORECAST_STATUS } from "@/components/forecasts/constants";
import { moment } from "@/utils/moment";

export function convertForecastInForecastWindow(forecastWindow) {
    if (forecastWindow.multiValidation) {
        // Only ZONE_FORECASTER get forecasts as embedded objects in a forecastWindow.
        // Hence, use the status/dates that are relevant for a secondary window.
        let today = moment();
        let startDate = moment(forecastWindow.startDate);
        let endDate = moment(forecastWindow.endDate);

        if (!forecastWindow.startDate || startDate.format("YYYYMMDD") > today.format("YYYYMMDD")) {
            forecastWindow.forecast.status = FORECAST_STATUS.PENDING;
        }
        if (forecastWindow.endDate && endDate.format("YYYYMMDD") < today.format("YYYYMMDD")) {
            forecastWindow.forecast.status = FORECAST_STATUS.CLOSED;
        }
    }
    return forecastWindow;
}



// WEBPACK FOOTER //
// ./src/components/forecasts/model/forecastWindow.js